<template lang="pug">
	<div class="forexcontainer" id="Forex">
		<span id="forexLoading"  v-show="!Object.keys(apiData).length > 0 && !retry == 0">
			<img src="/images/2015/forex_loading.gif" alt="currency trading" border="0" align="left" style="margin:0px 0px 10px 0px;"/><br>Real-Time Currency Quotes Loading
		</span>
		<span id="forexError" v-show="retry==0">
			Real-Time Currency Quotes<br><span style="font-size:28px; color:#DAD188;">Markets Closed or Unavailable</span>
		</span>
		<span id="forexLoaded" v-show="Object.keys(apiData).length > 0">
			<span style="display:block;padding-bottom:10px; border-bottom:1px solid #666666;">Real-Time Currency Quotes</span>
			<div class="table-responsive">
				<table id="forexTable" class="fxtable" width="100%" cellspacing="0" cellpadding="0" border="0">
						<tr v-for="sym in conIds.length/2">
							<td class="fxcurrency" width="10%" align="left" valign="middle">{{apiData[conIds[sym-1]]["symbol"]}}</td>
							<td class="fxbidaskspread" width="12%" align="left" valign="middle">BID <span class = "fxprice" v-bind:class="[apiData[conIds[sym-1]]['bDiff']]">{{apiData[conIds[sym-1]]["bPrice"]}}<sup>{{apiData[conIds[sym-1]]["bSup"]}}</sup></span></td>
							<td class="fxbidaskspread" width="14%" align="left" valign="middle">ASK <span class = "fxprice" v-bind:class="[apiData[conIds[sym-1]]['aDiff']]">{{apiData[conIds[sym-1]]["aPrice"]}}<sup>{{apiData[conIds[sym-1]]["aSup"]}}</sup></span></td>
							<td class="fxbidaskspread" width="12%" align="left" valign="middle">SPRD <span class="fxprice">{{apiData[conIds[sym-1]]["spread"]}}</span></td>
							<td v-if="sym==1" rowspan="4" width="1%" class="fxdivider"></td><td v-if="sym==1" rowspan="4" width="3%">&nbsp;</td>
							<td class="fxcurrency" width="10%" align="left" valign="middle">{{apiData[conIds[sym + conIds.length/2-1]]["symbol"]}}</td>
							<td class="fxbidaskspread" width="12%" align="left" valign="middle">BID <span class = "fxprice" v-bind:class="[apiData[conIds[sym-1]]['bDiff']]">{{apiData[conIds[sym + conIds.length/2-1]]["bPrice"]}}<sup>{{apiData[conIds[sym + conIds.length/2-1]]["bSup"]}}</sup></span></td>
							<td class="fxbidaskspread" width="14%" align="left" valign="middle">ASK <span class = "fxprice" v-bind:class="[apiData[conIds[sym-1]]['aDiff']]">{{apiData[conIds[sym + conIds.length/2-1]]["aPrice"]}}<sup>{{apiData[conIds[sym + conIds.length/2-1]]["aSup"]}}</sup></span></td>
							<td class="fxbidaskspread" width="12%" align="left" valign="middle">SPRD <span class="fxprice">{{apiData[conIds[sym + conIds.length/2-1]]["spread"]}}</span></td>
						</tr>
				</table>
			</div>
		</span>
	</div>
</template>
<script>
import api from './api/'

export default {
	components: {
	},

	data() {
		return {
			mdFields: [84, 86, 6509],
			apiData: {},
			prevData: {},
			conIds: [],
			retry: 4,
			options: { month: 'short', day: 'numeric', year: 'numeric', hourCycle: 'h24', day: '2-digit', hour: 'numeric', minute: 'numeric' }
		};
	},

	methods: {
		getSafeValue(val) {
			return val ? val : 0;
		},
		getSnapshot() {
			//store id for IBKR
			const id = "12087792,12087797,113342317,15016062,15016059,14433401,12087820,35045199";
			const conidData = {
				12087792: "EUR.USD",
				12087797: "GBP.USD",
				113342317: "USD.CNH",
				15016062: "USD.CAD",
				15016059: "USD.JPY",
				14433401: "AUD.USD",
				12087820: "USD.CHF",
				35045199: "USD.MXN"
			};
			api.getSnapshot({
				id,
				fields: this.mdFields
			})
			.then((response) => {
				//console.log("response", response);
				var res = response.slice();
				let datarec = 0;
				for(let i = 0; i < res.length; i++){
					datarec = 0;
					if (!(res[i][84] == undefined) || !(res[i][86] == undefined)) {
						let bidPrice = !(res[i][84] == undefined) ? res[i][84] : 0;
						let askPrice = !(res[i][86] == undefined) ? res[i][86] : 0;
						let spread = 0;
						if (askPrice === 0) {
							spread = bp;
						} else {
							spread = askPrice - bidPrice;
						}
						if(conidData[res[i]["conid"]] == "USD.JPY"){
							spread = (spread*100).toFixed(2).concat("p");
						} else { 
							spread = (spread*10000).toFixed(2).concat("p");
						}
						let conData = {
							symbol: conidData[res[i]["conid"]],
							bPrice: (bidPrice.length > 4)?bidPrice.substr(0,bidPrice.length-2):bidPrice,
							aPrice: (askPrice.length > 4)?askPrice.substr(0,askPrice.length-2):askPrice,
							bidPrice: bidPrice,
							askPrice: askPrice,
							bSup: (bidPrice.length > 4)?bidPrice.substr(bidPrice.length-1):"",
							aSup: (askPrice.length > 4)?askPrice.substr(askPrice.length-1):"",
							spread: spread
						};
						if(JSON.stringify(this.prevData) != "{}"){
						
							let preConData = this.prevData[res[i]["conid"]];
							if(askPrice > preConData["askPrice"]){
								conData	["aDiff"] = "fxpriceup";
							} else if(askPrice < preConData["askPrice"]){
								conData	["aDiff"] = "fxpricedown";
							} else {
								conData	["aDiff"] = "";
							}
							
							if(bidPrice > preConData["bidPrice"]){
								conData	["bDiff"] = "fxpriceup";
							} else if(bidPrice < preConData["bidPrice"]){
								conData	["bDiff"] = "fxpricedown";
							} else {
								conData	["bDiff"] = "";
							}
							
						} else {
							conData["aDiff"] = "";
							conData["bDiff"] = "";
						}
						this.apiData[res[i]["conid"]] = conData;
						datarec = 1;
					} else {
						retry--;
						break;
						/*if (this.retry-- > 0) {
							//console.debug("retry", this.retry);
							setTimeout(() => this.getSnapshot(), 2000);
						}*/
					}
				}
				if(datarec == 0){
					this.getSnapshot();
				} else {
					this.conIds = id.split(",");
					this.prevData = [];
					this.prevData = this.apiData;
					setTimeout(() => this.getSnapshot(), 6000);
				}
			})
			.catch(error => {
				//console.log(error);
				if (this.retry-- > 0) {
				//console.debug("retry", this.retry);
				setTimeout(() => this.getSnapshot(), 2000);
			}
			})
		}
	},
	mounted() {
		this.getSnapshot();
	}
}
</script>
